export default "__VITE_PUBLIC_ASSET__ebdc033a__"